import { LayoutComponent } from '@admin/core/components/layout/layout.component';
import { AuthenticatedGuard } from '@admin/core/guards/authenticated.guard';
import { AuthenticationInterceptor } from '@admin/core/interceptors/authentication.interceptor';
import { TokenService } from '@admin/core/services/token.service';
import { environment } from '@admin/environments';
import { AdminStatesModule } from '@admin/states';
import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgxHalStatesModule } from '@ngx-hal/states';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { NgxsModule } from '@ngxs/store';
import { AuthModule } from '@auth0/auth0-angular';

registerLocaleData(localeFr);

@NgModule({ declarations: [LayoutComponent],
    bootstrap: [LayoutComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MatBadgeModule,
        MatButtonModule,
        MatCardModule,
        MatDividerModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatSidenavModule,
        MatToolbarModule,
        MatDialogModule,
        AuthModule.forRoot(environment.auth0),
        NgxsModule.forRoot([], { developmentMode: !environment.production }),
        NgxsReduxDevtoolsPluginModule.forRoot({ disabled: environment.production }),
        NgxsRouterPluginModule.forRoot(),
        NgxHalStatesModule.forRoot(),
        AdminStatesModule.forRoot(),
        RouterModule.forRoot([
            {
                path: '',
                canActivate: [AuthenticatedGuard],
                loadChildren: () => import('../features/entities-management/entities-management.module').then(m => m.EntitiesManagementModule),
            },
        ], {
            onSameUrlNavigation: 'reload',
            paramsInheritanceStrategy: 'always',
        })], providers: [
        TokenService,
        AuthenticatedGuard,
        { provide: LOCALE_ID, useValue: 'en-US' },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthenticationInterceptor,
            multi: true,
        },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { appearance: 'fill' },
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class CoreModule {
  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
    this.matIconRegistry.addSvgIconSetInNamespace(
      `ref-portal`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons.svg`),
    );
  }
}
